import React from 'react';
import {
  Banner,
  BannerContent,
  BannerButton,
  BannerFlag,
  BannerHeader,
  BannerIcon,
  BannerGuidance,
  MediaBlockBody
} from '@trussworks/react-uswds';

export function USWDSBanner(props) {
  return <Banner {...props} />;
}

export function USWDSBannerContent(props) {
  return <BannerContent {...props} />;
}

export function USWDSBannerButton(props) {
  return <BannerButton {...props} />;
}

export function USWDSBannerFlag(props) {
  return <BannerFlag {...props} />;
}

export function USWDSBannerHeader(props) {
  return <BannerHeader {...props} />;
}

export function USWDSBannerIcon(props) {
  return <BannerIcon {...props} />;
}

export function USWDSBannerGuidance(props) {
  return <BannerGuidance {...props} />;
}

export function USWDSMediaBlockBody(props) {
  return <MediaBlockBody {...props} />;
}
